module.exports = __webpack_public_path__ + "img/FINANCEPR2.87148240.png";